import React, { useRef, useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaCheckCircle } from 'react-icons/fa';  // Icono para los items de la lista
import guinche from '../assets/BOMBA 3.jpg';

function Desarrollo() {
  const [startCount, setStartCount] = useState(false);
  const refMetrica = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1200 });

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
        } else {
          setStartCount(false);
        }
      },
      {
        threshold: 0.5,
      }
    );
    if (refMetrica.current) {
      observer.observe(refMetrica.current);
    }
    return () => {
      if (refMetrica.current) {
        observer.unobserve(refMetrica.current);
      }
    };
  }, []);

  return (
    <section className="py-16 bg-gray-100 mt-20">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Contenedor de dos columnas */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Columna izquierda - Imagen */}
          <div className="relative" data-aos="fade-right">
            <img
              src={guinche}
              alt="Imagen de Guinche"
              className="w-full h-auto object-cover rounded-lg shadow-lg transition-transform duration-500 ease-in-out transform hover:scale-105"
            />
          </div>

          {/* Columna derecha - Lista de puntos */}
          <div className="flex justify-start items-start" data-aos="fade-left">
            <ul className="list-none space-y-6 text-lg text-gray-700">
              <li className="flex items-center space-x-2">
                <FaCheckCircle className="text-blue-600" />
                <span>Aforo perforación nueva</span>
              </li>
              <li className="flex items-center space-x-2">
                <FaCheckCircle className="text-blue-600" />
                <span>Determinación de caudal, niveles estáticos y dinámicos, conductividad</span>
              </li>
              <li className="flex items-center space-x-2">
                <FaCheckCircle className="text-blue-600" />
                <span>Colocación de bomba final</span>
              </li>
              <li className="flex items-center space-x-2">
                <FaCheckCircle className="text-blue-600" />
                <span>Extracción de bomba para su reemplazo o mantenimiento</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Desarrollo;